import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type { GetSkillResponse, UseGetSkillParams, UseGetSkillResult } from '../types';

/**
 * Fetches a single skill by id, including its instructions, metadata, status,
 * version and current revision number. Backs the skill editor surface.
 */
const useGetSkill = ({ skillId, enabled = true }: UseGetSkillParams): UseGetSkillResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<GetSkillResponse>({
        pathname: `/skills/${skillId}`,
        method: 'GET',
        key: ['skill', skillId],
        queryOptions: {
            enabled: enabled && Boolean(skillId),
        },
    });

    return {
        skill: data?.data ?? null,
        isLoadingSkill: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetSkill;
